'use client';

import React from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import Logo from '@/assets/images/logofull.png'
import { Home, BookOpen, LineChart, User } from 'lucide-react';

import SidebarMenuContent from './SidebarMenuContent';

const SidebarMenu = ({name, email}: {name: string, email: string}) => {
  const pathname = usePathname();

  const hideSidebar = ['/login', '/register'].some((path) =>
    pathname?.startsWith(path)
  );

  if (hideSidebar) return null;

  return (
    <div className="hidden lg:fixed lg:left-0 lg:top-0 lg:flex lg:h-[100dvh] lg:max-h-[100dvh] lg:w-64 lg:flex-col lg:overflow-hidden flex-shrink-0 border-gray-200 bg-white z-20">
      <SidebarMenuContent name={name} email={email} />
    </div>
  );
};

export default SidebarMenu;